export default function lightThrottle(action, delay) {
  let lastCall = null
  return function lightThrottle_wrapper() {
    if (!lastCall || (Date.now() >= (lastCall + delay))) {
      lastCall = Date.now()
      action()
    }
  }
}
